module.exports = __webpack_public_path__ + "img/banner_zh.73e71030.png";